import {useCurrentFrame, useVideoConfig} from 'remotion';
import photosJson from './photos.json';
import refsJson from './refs.json';

// Local clock of the current Sequence, in seconds.
export const useT = () => {
 const frame = useCurrentFrame();
 const {fps} = useVideoConfig();
 return frame / fps;
};

export type Person = {id: string; name: string; email: string; file: string; photos: number};
// Fictional students of the demo project. Every image comes from the GSDG generator (work/gsdg-set, tools/import_gsdg.py). E-mails on example.com (RFC 2606).
export const PEOPLE: Person[] = [
 {id: 'camila_marinho', name: 'Camila Marinho', email: 'camila.marinho@example.com', file: 'camila_marinho.jpg', photos: 248},
 {id: 'diego_almeida', name: 'Diego Almeida', email: 'diego.almeida@example.com', file: 'diego_almeida.jpg', photos: 193},
 {id: 'juliana_santos', name: 'Juliana Santos', email: 'juliana.santos@example.com', file: 'juliana_santos.jpg', photos: 231},
 {id: 'mariana_albuquerque', name: 'Mariana Albuquerque', email: 'mariana.albuquerque@example.com', file: 'mariana_albuquerque.jpg', photos: 276},
 {id: 'sofia_leite', name: 'Sofia Leite', email: 'sofia.leite@example.com', file: 'sofia_leite.jpg', photos: 214},
];

export type Photo = {src: string; person: string; cat: string; w: number; h: number; faces: number[][]};
export const PHOTOS: Photo[] = photosJson as Photo[];
// Largest detected face first: the crops that read best at thumbnail size.
const faceArea = (p: Photo) => Math.max(0, ...p.faces.map(f => f[2] * f[3]));
// Each photo keeps only its largest face, so the face-framed crop centres one person instead of a group.
export const byFace = (ps: Photo[]) => ps.filter(p => p.faces.length).sort((a, b) => faceArea(b) - faceArea(a))
 .map(p => ({...p, faces: [p.faces.reduce((m, f) => f[2] * f[3] > m[2] * m[3] ? f : m)]}));
export const photosOf = (id: string) => byFace(PHOTOS.filter(p => p.person === id));

export type Ref = {src: string; w: number; h: number; face: number[]};
export const REFS = refsJson as Record<string, Ref>;

// Event galleries and their photo counts (they add up to TOTAL_PHOTOS); folder, name and size live in i18n.ts.
export const GALLERIES = [
 {cat: 'graduation', count: 3120},
 {cat: 'ball', count: 4260},
 {cat: 'campus', count: 2940},
 {cat: 'studio', count: 2160},
];
export const TOTAL_PHOTOS = GALLERIES.reduce((s, g) => s + g.count, 0);
export const IDENTIFIED = 186;
// One photo per person for a gallery mosaic.
export const galleryPhotos = (cat: string) => PEOPLE.map(p => byFace(PHOTOS.filter(x => x.cat === cat && x.person === p.id))[0]).filter(Boolean).slice(0, 4);


;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
